import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { waLink } from "@/lib/whatsapp";

const WhatsAppFloat = () => (
    <>
        {/* Desktop — botão flutuante em destaque */}
        <a
            href={waLink("geral")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-float"
            aria-label="Solicite seu orçamento pelo WhatsApp"
            className="hidden md:flex fixed bottom-8 right-8 z-50 items-center gap-3 bg-[#6A2022] text-white pl-5 pr-7 py-4 rounded-full shadow-xl shadow-[#6A2022]/30 wa-pulse transition-colors duration-300 hover:bg-[#7d282b]"
        >
            <WhatsAppIcon className="w-5 h-5" />
            <span className="text-[11px] tracking-[0.25em] uppercase font-bold whitespace-nowrap">
                Solicite seu orçamento
            </span>
        </a>

        {/* Mobile — barra inferior fixa */}
        <a
            href={waLink("geral")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-mobile-bar"
            className="md:hidden fixed bottom-0 inset-x-0 z-50 flex items-center justify-center gap-3 bg-[#6A2022] text-white py-4 text-[10px] tracking-[0.3em] uppercase font-bold"
        >
            <WhatsAppIcon className="w-4 h-4" />
            Solicitar orçamento pelo WhatsApp
        </a>
    </>
);

export default WhatsAppFloat;
